'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Immutable = require('Immutable');

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _TimeRange = require('MeetingsBase/models/TimeRange');

var _TimeRange2 = _interopRequireDefault(_TimeRange);

var _dates = require('MeetingsBase/utils/dates');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var weekDays = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];

var defaults = weekDays.reduce(function (accumulator, day) {
  return _extends({}, accumulator, _defineProperty({}, day, (0, _Immutable.List)()));
}, {});

var Availability = function (_Record) {
  _inherits(Availability, _Record);

  function Availability() {
    _classCallCheck(this, Availability);

    return _possibleConstructorReturn(this, (Availability.__proto__ || Object.getPrototypeOf(Availability)).apply(this, arguments));
  }

  _createClass(Availability, [{
    key: 'isValid',
    value: function isValid() {
      return this.every(function (timeRanges) {
        return timeRanges.every(function (timeRange) {
          return (0, _dates.validTimeRange)(timeRange);
        });
      });
    }
  }, {
    key: 'isEmpty',
    value: function isEmpty() {
      return this.reduce(function (t, a) {
        return t + a.size;
      }, 0) === 0;
    }
  }, {
    key: 'getForDateString',
    value: function getForDateString(dateString) {
      return this.get(weekDays[_I18n2.default.moment(dateString).day()]) || (0, _Immutable.List)();
    }
  }, {
    key: 'getForWeekDayIndex',
    value: function getForWeekDayIndex(i) {
      return this.get(weekDays[i]) || (0, _Immutable.List)();
    }
  }, {
    key: 'setForWeekDayIndex',
    value: function setForWeekDayIndex(availability, index) {
      return this.set(weekDays[index], availability);
    }
  }], [{
    key: 'from',
    value: function from(json) {
      var availability = this._fromWithoutValidation(json);

      return availability.reduce(function (newAvailability, timeRanges, dayKey) {
        newAvailability = newAvailability.set(dayKey, timeRanges.filter(function (timeRange) {
          return (0, _dates.validTimeRange)(timeRange);
        }));

        return newAvailability;
      }, new Availability());
    }
  }, {
    key: '_fromWithoutValidation',
    value: function _fromWithoutValidation(json) {
      if (!json) {
        return new Availability();
      }

      var formattedData = (0, _Immutable.Map)(json).map(function (timeRanges) {
        var timeRangesList = !Array.isArray(timeRanges) ? (0, _Immutable.Map)(timeRanges).toList() : (0, _Immutable.List)(timeRanges);

        return timeRangesList.map(_TimeRange2.default.from);
      });

      var sortedAvailability = formattedData.map(function (timeRanges) {
        return timeRanges.sort(function (timeRangeA, timeRangeB) {
          return timeRangeA.end - timeRangeB.end;
        });
      });

      return sortedAvailability;
    }
  }]);

  return Availability;
}((0, _Immutable.Record)(defaults));

exports.default = Availability;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsBase/target/src/MeetingsBase/static-1.2449/js/models/Availability.js
// module id = 186
// module chunks = 0